import { FC } from "react";
import { useFilterContext } from "@app/network-portfolio-management/contexts/FilterContext";
import { QESAlert } from "@app/shared/qes-standards/Alert";

const STALE_VIEW_MESSAGE =
  "Some of this saved view's filters could not be loaded and were left off. " +
  "Re-save the view to keep the filters that did load and clear this message.";

/**
 * Banner shown above the filter bar when an applied saved view was persisted before a filter's shape changed, so
 * the backend could not deserialize part of it. The unreadable filters are dropped while every other filter is
 * applied; this tells the user to re-save the view to repair it. The API also reports which filter properties
 * failed, but this banner shows one fixed message rather than naming them.
 */
export const StaleSavedViewNotice: FC = () => {
  const { savedViewFilterLoadError } = useFilterContext();

  if (!savedViewFilterLoadError) {
    return null;
  }

  return (
    <QESAlert type="warning" persist={true}>
      <span data-testid="npm-stale-saved-view-notice">{STALE_VIEW_MESSAGE}</span>
    </QESAlert>
  );
};
